<template>
<div class="add-confirm-view">
    <div class="add-confirm">
      <div class="add-confirm-top">
        <div class="add-confirm-top-back-btn" @click.stop="backToManageView">
          <img src="@/assets/h5/file/icon_file_manage_back.png">
        </div>
        <div class="add-confirm-top-title">{{$t("添加协作者#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}</div>
      </div>

      <div v-if="myAuth === 'ALL'" ref="inputContainer" class="popover-share-search" @mouseenter="hoverInput(true)" @mouseleave="hoverInput(false)">
        <div class="member-input">
          <div ref="searchInput" class="search-input" contenteditable="true" @input="searchMembers" :data-placeholder="$t('搜索用户添加权限#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1')" @focus="searchInputFocus" @blur="handleBlur" @keydown="handleKeyDown"></div>
          <FileShareSearchView v-show="showSearchResult" :searchText="searchText" :originData="originData" @selectMember="selectMember"></FileShareSearchView>
          <div v-show="searchText" class="clear-btn" @click.stop="clearText">
            <svg-icon icon-class="file-transfer-input-clear" class="clear-icon"></svg-icon>
          </div>
        </div>
      </div>

      <FileShareAddBatchModifyAuth :contentType="contentType" @selectBatchAuth="selectBatchAuth"></FileShareAddBatchModifyAuth>

      <div class="add-confirm-center">
        <div class="add-confirm-worker-item" v-for="(item, index) in shouldAddMemberList">
          <div class="worker-avatar">
            <div v-if="
                item.type === 0 &&
                  (item.memberAvatar === '' ||
                    item.memberAvatar === undefined ||
                    item.memberAvatar === null)
              " class="user-avatar" :style="avatarColorStye(item.memberName)">
              <div class="user-name">{{ userName(item.memberName) }}</div>
            </div>
            <img v-else :src="fileAvatar(item)">
          </div>
          <div class="worker-info">
            <div v-if="shouldAddMemberName(item).length < 11" class="worker-name">
              {{ shouldAddMemberName(item) }}
            </div>
            <moo-tooltip v-else placement="top" popper-class="tooltip_css" :content="shouldAddMemberName(item)" :visible-arrow="false">
              <div class="worker-name">
                {{ shouldAddMemberName(item) }}
              </div>
            </moo-tooltip>
            <div v-if="item.spaceId && spaceId !== item.spaceId && item.spaceName" class="worker-space-name">
              @{{ item.spaceName }}
            </div>
          </div>
          <moo-dropdown trigger="click" placement="bottom-end" @command="(cmd) => handlerChangeAuth(cmd, index)" @visible-change="(v) => dropdownMenuVisibleChange(v, index)">
            <div class="worker-auth-editable" @click="openAuthList(index)" @mouseover="mouseAction(index, true)" @mouseleave="mouseAction(index, false)">
              {{ authName(item.auth) }}
              <img :src="changeEditableIcon(index)">
            </div>
            <moo-dropdown-menu slot="dropdown">
              <div class="auth-list" v-for="(auth, i) in authList" :key="i">
                <moo-dropdown-item :command="i" :divided="['ALL', 'DELETE'].includes(auth.id)" :disabled="item.edit === false || isDisabledAuth(auth)">
                  <div class="auth-name" :style="computedAuthStyle(auth, item)">
                    <img v-show="auth.id === item.auth" src="@/assets/h5/file/icon_file_selected.png">{{ auth.name }}
                  </div>
                  <div class="auth-desc">{{ auth.desc }}</div>
                </moo-dropdown-item>
              </div>
            </moo-dropdown-menu>
          </moo-dropdown>
        </div>
      </div>
    </div>
    <div class="add-confirm-bottom">
      <div class="push-message">
        <span>
          <moo-checkbox v-model="pushMessage">
            <span class="text" :class="messageClass">{{$t("发送通知消息#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}</span>
          </moo-checkbox>
        </span>
      </div>
      <div class="add-confirm-bottom-cancel-btn" @click="backToManageView">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}      </div>
      <div class="add-confirm-bottom-add-btn" @click="addMembers">{{$t("添加#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}</div>
    </div>

    <moo-dialog :top="isPcMode ? '35vh' : '35vh'" custom-class="cloud-common-dialog" :visible.sync="showDialog" :modal-append-to-body="false" :width="isPcMode ? '448px' : '84%'" @closed="showDialog = false">
      <div v-if="isPcMode">
        <div class="title">
          <svg-icon class-name="dialog-icon" icon-class="file-warning"></svg-icon>{{$t("提示#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}        </div>
        <div class="content">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}        </div>
        <div class="footer">
          <div class="custom-button link-button" @click="showDialog = pushMessage = false">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_2")}}          </div>
          <div class="custom-button reconnect-button" @click="addConfirm">{{$t("确认发送#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1")}}          </div>
        </div>
      </div>
      <div class="mobile-content" v-else>
        <div class="title">{{$t("提示#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_2")}}</div>
        <div class="content" :style="{ 'padding-left': '0px' }">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_2")}}        </div>
        <div class="footer" :style="'justify-content: space-evenly;'">
          <div class="custom-button" @click="showDialog = pushMessage = false">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_3")}}          </div>
          <div class="custom-button reconnect-button" :style="'margin-left: 0px;'" @click="addConfirm">{{$t("确认发送#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_2")}}          </div>
        </div>
      </div>
    </moo-dialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapState } from "vuex";
import { setFileAuth } from "@/api/h5/file";
import { AUTH_DETAIL_LIST } from "@/constants/file";
import { getNameColor, getLastName } from "@/utils/color";
import FileShareSearchView from "./FileShareSearchView";
import { setSaviorConfigure, updateSaviorData } from "../../utils/savior";
import FileShareAddBatchModifyAuth from './FileShareAddBatchModifyAuth.vue';

export default {
  name: "FileShareAddConfirmView",
  components: {
    FileShareSearchView,
    FileShareAddBatchModifyAuth
  },
  props: {
    fileId: {
      type: String
    },
    addData: {
      type: Array
    },
    originData: {
      type: Array
    },
    spaceId: {
      type: String
    },
    nonAdminMaxAuth: {
      type: String,
      default: ""
    },
    myAuth: {
      type: String
    },
    isMettingDoc: {
      type: Boolean,
      default: false
    },
    contentType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      shouldAddMemberList: this.addData,
      editableHover: [],
      editableFocus: [],
      authList: AUTH_DETAIL_LIST,
      pushMessage: true,
      showDialog: false,
      searchText: "",
      isFocus: false,
      selectedMember: null,
      showSearchResult: true,
      defaultBatchAuth: 'READ_DOWNLOAD'
    };
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode
    }),
    messageClass() {
      return this.pushMessage ? "" : "disable";
    },
    shouldAddMemberName() {
      return (item) => {
        if (item.type === 0) {
          return item.memberName;
        } else if (item.type === 1) {
          return item.departmentName;
        } else {
          return item.name;
        }
      };
    }
  },
  created() {
    for (let i = 0; i < this.shouldAddMemberList.length; i++) {
      this.editableHover.push(false);
      this.editableFocus.push(false);
    }
    this.shouldAddMemberList.map((item) => {
      if (!item.auth) {
        if (
        this.contentType === 'DOCUMENT' ||
        this.contentType === 'EXCEL' ||
        this.contentType === 'PPT' ||
        this.contentType === 'PDF' ||
        this.contentType === 'WORD') {
          item.auth = "READ";
        } else {
          item.auth = "READ_DOWNLOAD";
        }
      }
      if (item.type !== 0) {
        this.pushMessage = false;
      }
    });
    this.authList = this.authList.filter((i) => i.id !== "RECOVER");
  },
  methods: {
    selectBatchAuth(authId) {
      this.defaultBatchAuth = authId;
      // 深拷贝
      const tmpAddMemberList = JSON.parse(JSON.stringify(this.shouldAddMemberList));
      this.shouldAddMemberList = [];
      for (let index = 0; index < tmpAddMemberList.length; index++) {
        tmpAddMemberList[index].auth = authId;
        this.shouldAddMemberList.push(tmpAddMemberList[index]);
      }
    },
    isDisabledAuth(auth) {
      if (this.nonAdminMaxAuth) {
        const newAuthList = this.authList.filter(
          (i) => i.id !== "NONE" && i.id !== "DELETE" && i.id !== "RECOVER"
        );
        const maxAuthIndex = newAuthList.findIndex(
          (i) => i.id === this.nonAdminMaxAuth
        );
        const authIndex = newAuthList.findIndex((i) => i.id === auth.id);
        return maxAuthIndex < authIndex;
      } else {
        return false;
      }
    },
    computedAuthStyle(auth, item) {
      const disabledStyle = "color: #CCCED7 !important; margin-left: 36px";
      const activeStyle = "color: #5C70FF !important";
      const normalStyle = "color: #222329 !important; margin-left: 36px";
      const specailStyle = "color: #FF4747 !important; margin-left: 36px";
      const specailActiveStyle = "color: #FF4747 !important;";

      if (["DELETE"].includes(auth.id)) {
        if (auth.id === item.auth) {
          return specailActiveStyle;
        } else {
          return specailStyle;
        }
      } else {
        const disabled = this.isDisabledAuth(auth);
        if (disabled) {
          return disabledStyle;
        }
        if (auth.id === item.auth) {
          return activeStyle;
        } else {
          return normalStyle;
        }
      }
    },
    backToManageView() {
      this.$emit("backToManageView");
    },
    authName(auth) {
      switch (auth) {
        case "ALL":
          return intl.$t("所有权限#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1");
        case "READ":
          return intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1");
        case "READ_DOWNLOAD":
          return intl.$t("查看下载#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1");
        case "WRITE":
          return intl.$t("编辑#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1");
      }
    },
    handlerChangeAuth(command, index) {
      if (this.authList[command].id === "DELETE") {
        /// 删除协作者
        this.shouldAddMemberList.splice(index, 1);
        if (this.shouldAddMemberList.length === 0) {
          this.backToManageView();
        } else {
          if (!this.shouldAddMemberList.some((item) => item.type !== 0)) {
            this.pushMessage = true;
          }
        }
      } else {
        this.$set(
          this.shouldAddMemberList[index],
          "auth",
          this.authList[command].id
        );
      }
    },
    openAuthList(index) {
      this.$set(this.editableFocus, index, !this.editableFocus[index]);

      if (!this.editableFocus[index]) {
        return;
      }
    },
    dropdownMenuVisibleChange(visible, index) {
      if (!visible) {
        this.$set(this.editableFocus, index, visible);
        this.$set(this.editableHover, index, visible);
      }
    },
    mouseAction(index, isHover) {
      if (this.editableFocus[index] === true && !isHover) {
        this.$set(this.editableHover, index, true);
        return;
      }
      this.$set(this.editableHover, index, isHover);
    },
    changeEditableIcon(index) {
      return this.editableFocus[index] ?
      require("@/assets/h5/file/icon_file_auth_editable_selected.png") :
      this.editableHover[index] ?
      require("@/assets/h5/file/icon_file_auth_editable_hover.png") :
      require("@/assets/h5/file/icon_file_auth_editable.png");
    },
    addMembers() {
      if (
      this.shouldAddMemberList.some(
        (item) => (item.type === 1 || item.type === 2) && this.pushMessage
      ))
      {
        this.showDialog = true;
      } else {
        this.addConfirm();
      }
    },
    addConfirm() {
      setSaviorConfigure({
        expandfield: {
          source: this.isMettingDoc === true ? "meeting" : "docs",
          fid: this.fileId
        }
      });
      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "add_collaborator",
        eventid: "cloud_document_operation"
      });
      setSaviorConfigure({ expandfield: {} });
      this.showDialog = false;
      /// 修改权限
      const fileId = this.fileId;
      let confirmAddList = [];
      this.shouldAddMemberList.map((item) => {
        let toType = "";
        let to = "";
        switch (item.type) {
          case 0:
            toType = "PERSON";
            to = item.userId;
            break;
          case 1:
            toType = "DEPARTMENT";
            to = item.departmentId;
            break;
          case 2:
            toType = "USER_GROUP";
            to = item.id;
            break;
          case 3:
            toType = "GROUP";
            to = item.id;
        }
        confirmAddList.push({
          auth: item.auth,
          to: to,
          toSpace: item.spaceId ?? this.spaceId,
          toType: toType
        });
      });
      const data = {
        fileId: fileId,
        list: confirmAddList,
        pushMessage: this.pushMessage
      };
      setFileAuth(data).
      then((res) => {
        if (res.code === 200) {
          this.$message({
            message: intl.$t("添加协作者成功#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1"),
            type: "success"
          });
          setTimeout(() => {
            this.backToManageView();
          }, 600);
        } else {
          this.$message({
            message: intl.$t(`添加协作者失败，{slot0}#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1`, { slot0: res.message }),
            type: "error"
          });
        }
      }).
      catch((err) => {
        this.$message({
          message: intl.$t("添加协作者失败#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1"),
          type: "error"
        });
      });
    },
    fileAvatar(item) {
      if (item.type === 0) {
        return item.memberAvatar;
      } else if (item.type === 2) {
        return require("@/assets/h5/file/fp_user_group.png");
      } else if (item.type === 3) {
        return item.avatar;
      } else if (item.type === 1 && item.spaceId !== this.spaceId) {
        return require("@/assets/h5/file/finder_dept_sub_united.png");
      } else {
        return require("@/assets/h5/file/icon_file_file.png");
      }
    },
    avatarColorStye(name) {
      let avatarColor = getNameColor(name);
      return `background-color: ${avatarColor}`;
    },
    userName(name) {
      return getLastName(name);
    },
    hoverInput(isHover) {
      if (isHover) {
        this.inputContainerBorderStyle(true);
      } else {
        if (!this.isFocus) {
          this.inputContainerBorderStyle(false);
        }
      }
    },
    selectMember(item) {
      this.showSearchResult = false;
      this.selectedMember = item;
      this.$refs.searchInput.innerText = this.searchText = "";
      this.inputContainerBorderStyle(false);
      this.isFocus = false;

      let isOwner = false;
      let isAdmin = false;
      let exsitMember = this.originData.find((member) => {
        if (
        member.toSpace === item.spaceId &&
        member.to === item.userId && (
        member.memberIdentity === "ADMIN" ||
        member.memberIdentity === "OWNER"))
        {
          if (member.memberIdentity === "ADMIN") {
            isAdmin = true;
          } else if (member.memberIdentity === "OWNER") {
            isOwner = true;
          }
        }
        return member.toSpace === item.spaceId && member.to === item.userId;
      });

      if (exsitMember) {
        if (isOwner) {
          this.$message.warning(intl.$t("该用户为文档所有者，请勿重复添加#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1"));
          return;
        } else if (isAdmin) {
          this.$message.warning(intl.$t("该用户为管理员，请勿重复添加#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1"));
          return;
        }
      }

      let isExsit = this.shouldAddMemberList.some((member) => {
        return member.spaceId === item.spaceId && member.userId === item.userId;
      });

      if (isExsit) {
        this.$message.warning(intl.$t("该用户已添加，请勿重复添加#!!!#src/pages/H5/Cloud/components/share/FileShareAddConfirmView.vue_1"));
        return;
      }

      this.shouldAddMemberList.unshift({
        memberName: item.memberName,
        memberAvatar: item.memberAvatar,
        memberUniqueId: item.id,
        spaceId: item.spaceId,
        type: 0,
        userId: item.userId,
        spaceName: item.spaceName,
        auth: exsitMember ? exsitMember.auth : this.defaultBatchAuth ? this.defaultBatchAuth : "READ_DOWNLOAD"
      });
    },
    searchMembers(event) {
      this.selectedMember = null;
      this.showSearchResult = true;
      this.searchText = event.target.innerText;
    },
    searchInputFocus() {
      this.isFocus = true;
      this.inputContainerBorderStyle(true);
      this.handleRange();
    },
    handleRange() {
      this.$nextTick(() => {
        const range = document.createRange();
        const sel = window.getSelection();
        this.$refs.searchInput.focus();
        const childNodes = this.$refs.searchInput.childNodes;
        if (childNodes.length > 0) {
          const lastNode = childNodes[childNodes.length - 1];
          range.setStart(lastNode, lastNode.length || 0);
          range.collapse(true);
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      });
    },
    handleBlur() {
      this.isFocus = false;
      if (this.searchText) {
        this.inputContainerBorderStyle(false);
        setTimeout(() => {
          this.showSearchResult = false;
        }, 200);
      } else {
        this.inputContainerBorderStyle(false);
      }
    },
    handleKeyDown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
    clearText() {
      this.$refs.searchInput.innerText = this.searchText = "";
      this.$refs.searchInput.focus();
    },
    inputContainerBorderStyle(hasBorder) {
      if (hasBorder) {
        this.$refs.inputContainer.style.border = "1px solid #5C70FF";
      } else {
        this.$refs.inputContainer.style.border = "1px solid #A2A4B0";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-confirm-view {
  display: flex;
  flex-direction: column;
  flex: 1;

  .add-confirm {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 16px 16px 0px 16px;

    .add-confirm-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      line-height: 100%;
      margin-bottom: 24px;

      .add-confirm-top-back-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        margin-right: 4px;
        cursor: pointer;

        img {
          width: 14px;
          height: 14px;
          object-fit: contain;
        }

        &:hover {
          background-color: #f4f6f9;
          border-radius: 4px;
        }
      }

      .add-confirm-top-title {
        display: flex;
        flex: 1;
        font-size: 16px;
        font-weight: 500;
        font-family: "PingFang SC", sans-serif;
        color: #121317;
        line-height: 24px;
      }
    }

    .popover-share-search {
      margin-bottom: 8px;
      width: 100%;
      height: 32px;
      box-sizing: border-box;
      border: 1px solid #A2A4B0;
      border-radius: 6px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      .member-input {
        width: 100%;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;

        .search-input {
          display: inline-flex;
          flex: 1;
          padding: 6px 12px;
          background: transparent;
          border: none;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #121317;
          text-align: left;

          &:empty::before {
            content: attr(data-placeholder);
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #8f959e;
            letter-spacing: 0;
            line-height: 20px;
            cursor: text;
          }

          &:focus-visible {
            outline: none;
          }
        }

        .clear-btn {
          width: 16px;
          height: 16px;
          padding-right: 12px;
          display: flex;
          cursor: pointer;

          .clear-icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    .add-confirm-center {
      display: flex;
      flex-direction: column;
      max-height: 160px;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .add-confirm-worker-item {
        width: 100%;
        height: 40px;
        margin-bottom: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        cursor: pointer;

        &:hover {
          background-color: #f4f6f9;
          border-radius: 8px;
        }

        .worker-avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          margin-right: 12px;
          margin-left: 4px;

          img {
            width: 32px;
            height: 32px;
            border-radius: 8px;
          }

          .user-avatar {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .user-name {
              font-family: "PingFang SC", sans-serif;
              font-weight: 600;
              font-size: 12px;
              color: #ffffff;
              letter-spacing: 0;
              line-height: 17px;
            }
          }
        }

        .worker-info {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          flex: 1;
          height: 100%;
          margin-right: 4px;

          .worker-name {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #323233;
            letter-spacing: 0;
            line-height: 20px;
            margin-right: 8px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .worker-space-name {
            margin-left: 4px;
            color: #fc7d29;
            font-family: PingFangSC-Regular;
            font-weight: 300;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            display: flex;
            flex-shrink: 0;
          }
        }

        .worker-auth-editable {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 32px;
          padding: 0 8px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #222329;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          border: none;
          background-color: transparent;
          cursor: pointer;

          &:hover {
            color: #5c70ff;
          }

          img {
            margin-left: 4px;
            width: 10px;
            height: 10px;
            object-fit: contain;
          }

          .editable-icon {
            margin-left: 4px;
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }

  .add-confirm-bottom {
    height: 64px;
    width: 100%;
    background-color: #f5f6f7;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    border-radius: 0 0 10px 10px;

    .push-message {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      margin-left: 16px;

      .text {
        color: #222329;
        line-height: 30px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
      }

      .disable {
        color: #222329;
      }
    }

    .add-confirm-bottom-cancel-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC", sans-serif;
      color: #222329;
      line-height: 20px;
      background-color: #ffffff;
      width: 68px;
      height: 36px;
      border-radius: 8px;
      border: 1px solid #e6e8ec;

      &:hover {
        background-color: #f4f6f9;
      }
    }

    .add-confirm-bottom-add-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      font-family: "PingFang SC", sans-serif;
      color: #fff;
      line-height: 20px;
      background-color: #5c70ff;
      width: 68px;
      height: 36px;
      border-radius: 8px;

      &:hover {
        background-color: #6d7dff;
      }
    }
  }
}

.moo-popper {
  margin-top: 8px !important;
  margin-right: 8px !important;
  padding: 4px 0px 0px 0px !important;
  background: #ffffff !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  width: 258px !important;
}

.moo-dropdown-menu__item {
  min-height: 28px !important;
  padding: 0 0 !important;
  margin: 4px 4px 4px 4px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9 !important;
    border-radius: 8px !important;
  }

  .auth-name {
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: PingFangSC-Regular !important;
    color: #222329 !important;
    line-height: 20px;
    margin-top: 4px;

    img {
      width: 15px;
      height: 11px;
      margin: 0 11px;
    }
  }

  .auth-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #a5a7b3;
    letter-spacing: 0;
    line-height: 17px;
    margin: 0 16px 4px 36px;
    white-space: pre-wrap !important;
    word-break: break-word;
  }
}

.moo-dropdown-menu__item--divided {
  border-top: 1px solid #f1f4f5;
}

::v-deep .moo-checkbox__inner {
  width: 16px;
  height: 16px;
  border: 1px solid rgb(0, 0, 0, 0.3);
  background-color: #f2f3f4;
}

::v-deep .moo-checkbox__input.is-disabled.is-checked .moo-checkbox__inner {
  background-color: #dcdfe6 !important;
  border-color: #dcdfe6 !important;
}

::v-deep .moo-checkbox__input.is-checked .moo-checkbox__inner,
::v-deep .moo-checkbox__input.is-indeterminate .moo-checkbox__inner {
  background-color: #5c70ff !important;
  border-color: #5c70ff !important;
}

::v-deep .moo-checkbox__label {
  padding-left: 8px;
}

::v-deep .moo-checkbox__inner::after {
  height: 8px;
  left: 5px;
  width: 4px;
  top: 2px;
}

.moo-checkbox__input.is-disabled.is-checked .moo-checkbox__inner::after {
  border-color: #fff;
}
</style>

<style lang="scss">
@import "~@/styles/cloudCommonDialog.scss";

.tooltip_css {
  border-radius: 8px !important;
  color: #767c85 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  padding: 8px !important;
  background-color: #ffffff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  max-width: 400px !important;
}
</style>
